import Dialog from 'global/guides/Dialog'

interface IProps {
    open: boolean
    nome: string
    onOk: () => void
}

export function AvisoSegmentoPendente({ open, nome, onOk }: IProps) {
    return (
        <Dialog.Root
            width="auto"
            height="auto"
            open={open}
            onSubmit={onOk}
            onClose={() => {}}
            disableEscapeKeyDown
        >
            <Dialog.Content>
                É necessário informar o segmento de atuação de{' '}
                <strong>&quot;{nome}&quot;</strong> para continuar.
            </Dialog.Content>
            <Dialog.Actions>
                <Dialog.Actions.PrimaryButton closeOnSubmit>
                    Ok
                </Dialog.Actions.PrimaryButton>
            </Dialog.Actions>
        </Dialog.Root>
    )
}
